<template src="@/components/AppFooter.html" />
<style lang="scss" src="@/components/AppFooter.scss" />

<script lang="ts">

import { SfFooter, SfImage, SfList, } from '@storefront-ui/vue';
import { OrkReassurance, OrkSocial, OrkNewsletter } from "@/components/Ork";
import { configuration } from "@/config/InstanceConfiguration";
import { NewsletterFooterDisplayStrategy, FooterMenuItemType } from "~/core/config/InstanceConfiguration";
import { RouterLink } from 'vue-router';

export default {
    name: "AppFooter",
    components: {
        SfImage,
        SfFooter,
        SfList,
        OrkSocial,
        OrkReassurance,
        OrkNewsletter,
        RouterLink
    },

    data() {
        return {
            loading: true,
            FooterMenuItemType
        }
    },
    computed: {
        showReassurance() { return configuration.footer.showFooterReassurance },
        showNewsletter() { return configuration.footer.showNewsletter },
        showNewsletterFullWidthBeforeColumns() { return configuration.footer.newsletter.enabled && configuration.footer.newsletter.strategy === NewsletterFooterDisplayStrategy.FULL_WIDTH_BEFORE_COLUMNS },
        showNewsletterInsideLastColumn() { return configuration.footer.newsletter.enabled && configuration.footer.newsletter.strategy === NewsletterFooterDisplayStrategy.INSIDE_LAST_COLUMN },
        showMenuCol1() { return configuration.footer.menuCol1?.items?.length },
        showMenuCol2() { return configuration.footer.menuCol2?.items?.length },
        showMenuCol3() { return configuration.footer.menuCol3?.items?.length },
        showMenuAnnexe() { return configuration.footer.menuAnnexe?.items?.length },
        showColumns() { return this.showMenuCol1 || this.showMenuCol2 || this.showMenuCol3 || this.showNewsletter },
        copyrightYear() { return new Date().getFullYear() },
        corporateName() { return configuration.corporateName },
        social() { return configuration.footer.social },
        menuCol1() { return configuration.footer.menuCol1 },
        menuCol2() { return configuration.footer.menuCol2 },
        menuCol3() { return configuration.footer.menuCol3 },
        menuAnnexe() { return configuration.footer.menuAnnexe },
        menuColumns() { return [this.menuCol1, this.menuCol2, this.menuCol3] },
        contactInfo() { return configuration.footer.contactInfo },
    }
};
</script>